<!-- OTP Verification -->
<div *ngIf="!isEmailVerified" class="auth-panel">
  <div class="auth-heading">
    <span class="auth-title">OTP Verification</span>
    <p class="auth-subtitle">Enter the 6-digit code sent to your email</p>
  </div>

  <div [formGroup]="otpForm" class="auth-body">
    <div class="otp-row">
      <ng-container *ngFor="let i of [0,1,2,3,4,5]">
        <input
          type="text"
          inputmode="numeric"
          maxlength="1"
          class="otp-input"
          [formControl]="getOtpControl(i)"
          (input)="onOtpInput($event, i)"
        />
      </ng-container>
    </div>

    <button type="button" class="auth-submit" (click)="submitOtp()">
      Verify
    </button>

    <button type="button" class="auth-text-link" (click)="resendOtp()">
      Resend OTP
    </button>
  </div>
</div>

<!-- Set Password -->
<div *ngIf="isEmailVerified" class="auth-panel">
  <div class="auth-heading">
    <span class="auth-title">Set Password</span>
    <p class="auth-subtitle">Create a secure password for your organization account</p>
  </div>

  <form [formGroup]="passwordForm" class="auth-body" (ngSubmit)="submitPassword()">
    <div class="auth-field">
      <label class="auth-field-label" for="set-password">Password</label>
      <div class="auth-input-wrap">
        <input
          id="set-password"
          class="auth-input"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          placeholder="Enter password"
          autocomplete="new-password"
        />
        <button
          type="button"
          class="password-toggle-btn"
          (click)="showPassword = !showPassword"
          [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
        >
          <img
            [src]="showPassword ? '../../assets/image/eye.svg' : '../../assets/image/closeeye.svg'"
            alt=""
            class="w-5 h-5 opacity-70"
          />
        </button>
      </div>

      <div class="strength-track" aria-hidden="true">
        <span class="strength-bar" [class.on]="passwordStrength() >= 1" [class.warn]="passwordStrength() < 4" [class.ok]="passwordStrength() >= 4"></span>
        <span class="strength-bar" [class.on]="passwordStrength() >= 2" [class.warn]="passwordStrength() < 4" [class.ok]="passwordStrength() >= 4"></span>
        <span class="strength-bar" [class.on]="passwordStrength() >= 3" [class.warn]="passwordStrength() < 5" [class.ok]="passwordStrength() >= 5"></span>
        <span class="strength-bar" [class.on]="passwordStrength() >= 4" [class.ok]="passwordStrength() >= 4"></span>
      </div>
      <p class="strength-label">{{ passwordStrengthLabel() }}</p>

      <ul class="rule-list">
        <li [class.met]="passwordRules().minLength">At least 8 characters</li>
        <li [class.met]="passwordRules().upper">One uppercase letter</li>
        <li [class.met]="passwordRules().lower">One lowercase letter</li>
        <li [class.met]="passwordRules().number">One number</li>
        <li [class.met]="passwordRules().special">One special character</li>
      </ul>

      <div class="auth-error" *ngIf="passwordForm.get('password')?.touched && passwordForm.get('password')?.invalid">
        <p *ngIf="passwordForm.get('password')?.errors?.['required']">Password is required.</p>
        <p *ngIf="passwordForm.get('password')?.errors?.['pattern'] || passwordForm.get('password')?.errors?.['minlength']">
          Password must meet all requirements.
        </p>
      </div>
    </div>

    <div class="auth-field">
      <label class="auth-field-label" for="confirm-password">Confirm Password</label>
      <div class="auth-input-wrap">
        <input
          id="confirm-password"
          class="auth-input"
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="confirm_password"
          placeholder="Re-enter password"
          autocomplete="new-password"
        />
        <button
          type="button"
          class="password-toggle-btn"
          (click)="showConfirmPassword = !showConfirmPassword"
          [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'"
        >
          <img
            [src]="showConfirmPassword ? '../../assets/image/eye.svg' : '../../assets/image/closeeye.svg'"
            alt=""
            class="w-5 h-5 opacity-70"
          />
        </button>
      </div>
      <div class="auth-error" *ngIf="passwordForm.errors?.['passwordMismatch'] && (passwordForm.get('confirm_password')?.touched || passwordForm.touched)">
        Passwords do not match.
      </div>
    </div>

    <button type="submit" class="auth-submit" [disabled]="passwordForm.invalid">
      Set Password
    </button>

    <a class="auth-text-link" routerLink="/">Go to Login</a>
  </form>
</div>
